import type { JSX } from 'react';
export const chunkElementArray = (
  objects: JSX.Element[],
  chunkSize: number = 3,
): JSX.Element[][] => {
  return objects.reduce(
    (acc: JSX.Element[][], curr: JSX.Element, index: number) => {
      if (index % chunkSize === 0) acc.push([]); // Start a new chunk
      acc[acc.length - 1]?.push(curr); // Add the current object to the current chunk
      return acc;
    },
    [],
  );
};
